import { Component, ChangeDetectionStrategy, input, computed } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'widget-qr-kod',
  standalone: true,
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <svg [attr.width]="boyut()" [attr.height]="boyut()"
         [attr.viewBox]="'0 0 ' + gridBoyut() + ' ' + gridBoyut()"
         xmlns="http://www.w3.org/2000/svg"
         shape-rendering="crispEdges">
      <rect x="0" y="0" [attr.width]="gridBoyut()" [attr.height]="gridBoyut()" [attr.fill]="arkaPlanRenk()" />
      @for (hucre of hucreler(); track hucre.k) {
        <rect [attr.x]="hucre.x" [attr.y]="hucre.y" width="1" height="1" [attr.fill]="onPlanRenk()" />
      }
    </svg>
  `,
  styles: [`
    :host { display: inline-flex; line-height: 0; }
    svg { image-rendering: pixelated; }
  `],
})
export class QrKodComponent {
  veri = input('');
  boyut = input(120);
  onPlanRenk = input('#000000');
  arkaPlanRenk = input('#ffffff');

  private matris = computed(() => matrisOlustur(this.veri()));
  gridBoyut = computed(() => this.matris().length);

  hucreler = computed(() => {
    const m = this.matris();
    const n = m.length;
    const sonuc: { x: number; y: number; k: number }[] = [];
    let k = 0;
    for (let y = 0; y < n; y++)
      for (let x = 0; x < n; x++)
        if (m[y][x]) sonuc.push({ x, y, k: k++ });
    return sonuc;
  });
}

const FINDER = 7;
const MARGIN = 1;

function matrisOlustur(veri: string): number[][] {
  const bitler = metinBitlere(veri || ' ');
  const veriAlani = Math.ceil(Math.sqrt(bitler.length));
  const n = Math.max(veriAlani + FINDER + MARGIN * 2, FINDER * 2 + MARGIN * 3);
  const m = Array.from({ length: n }, () => new Array(n).fill(0));

  finderYerlestir(m, MARGIN, MARGIN);
  finderYerlestir(m, n - FINDER - MARGIN, MARGIN);
  finderYerlestir(m, MARGIN, n - FINDER - MARGIN);

  zamanlamaYerlestir(m, n);

  let bi = 0;
  for (let y = 0; y < n && bi < bitler.length; y++) {
    for (let x = 0; x < n && bi < bitler.length; x++) {
      if (hucreDolu(m, x, y, n)) continue;
      m[y][x] = bitler[bi++];
    }
  }

  return m;
}

function finderYerlestir(m: number[][], ox: number, oy: number) {
  for (let y = 0; y < FINDER; y++) {
    for (let x = 0; x < FINDER; x++) {
      const kenar = y === 0 || y === 6 || x === 0 || x === 6;
      const ic = y >= 2 && y <= 4 && x >= 2 && x <= 4;
      m[oy + y][ox + x] = kenar || ic ? 1 : 0;
    }
  }
}

function zamanlamaYerlestir(m: number[][], n: number) {
  const y = MARGIN + 6;
  const x = MARGIN + 6;
  for (let i = MARGIN + FINDER; i < n - MARGIN - FINDER; i++) {
    m[y][i] = i % 2 === 0 ? 1 : 0;
    m[i][x] = i % 2 === 0 ? 1 : 0;
  }
}

function hucreDolu(m: number[][], x: number, y: number, n: number): boolean {
  const finderBolgeler = [
    [MARGIN, MARGIN],
    [n - FINDER - MARGIN, MARGIN],
    [MARGIN, n - FINDER - MARGIN],
  ];
  for (const [fx, fy] of finderBolgeler) {
    if (x >= fx - 1 && x <= fx + FINDER && y >= fy - 1 && y <= fy + FINDER) return true;
  }
  if (y === MARGIN + 6 && x > MARGIN + FINDER - 1 && x < n - MARGIN - FINDER) return true;
  if (x === MARGIN + 6 && y > MARGIN + FINDER - 1 && y < n - MARGIN - FINDER) return true;
  return false;
}

function metinBitlere(metin: string): number[] {
  const bitler: number[] = [];
  for (let i = 0; i < metin.length; i++) {
    const kod = metin.charCodeAt(i) & 0xff;
    for (let b = 7; b >= 0; b--) bitler.push((kod >> b) & 1);
  }
  return bitler;
}
